import React, { useEffect } from 'react'
import { useGetDatabaseScopesService } from '../services/useGetDatabaseScopesService';

const DatabaseScopesFetcher = () => {
    const {getDatabaseScopes} = useGetDatabaseScopesService();
    useEffect(()=> {
        getDatabaseScopes();
    }, []);
  return null;
}

export default DatabaseScopesFetcher;